module.exports = __webpack_public_path__ + "static/media/ehealth-bg1-mobile.f742b4ab.jpg";